import React from 'react';
import '../styles/ServiceDetails.css';

function ServiceRealEstate() {
  return (
    <div className="page">

      {/* Hero */}
      <section className="hero">
        <div className="hero-inner">
          <h1 className="title">Ανέγερση &amp; Αξιοποίηση Ακινήτων</h1>
          <p className="subtitle">Construction And Real Estate Developement</p>
        </div>
      </section>

      {/* Intro */}
      <section className="intro">
        <div className="wrap">
          <p>
            Η ΚΑΡΤΕΡΙΑ Κατασκευαστική & Συμβουλευτική δραστηριοποιείται στην ανάπτυξη, ανέγερση και ολοκληρωμένη
            κατασκευή ακινήτων, με έμφαση στην ποιοτική και τεχνικά άρτια υλοποίηση έργων,
            παρέχοντας παράλληλα υπηρεσίες τεχνικής, οργανωτικής και λειτουργικής υποστήριξης σε
            όλα τα στάδια ανάπτυξης και αξιοποίησης ενός ακινήτου.
          </p>
          <p>
            Η προσέγγισή μας καλύπτει ολόκληρο τον κύκλο ζωής του έργου, από τη σύλληψη και την ωρίμανση της επένδυσης έως την κατασκευή,
            την παράδοση και τη λειτουργική αξιοποίηση του ακινήτου.
            Κάθε έργο αντιμετωπίζεται με γνώμονα τη βιωσιμότητα, τη λειτουργικότητα και τη μακροχρόνια διατήρηση της αξίας του.
          </p>
        </div>
      </section>

      {/* Αντικείμενο */}
      <section className="services">
        <div className="wrap">
          <h2 className="heading">Αντικείμενο Υπηρεσιών</h2>
          <p className="lead">
            Οι υπηρεσίες CONSTRUCTION AND REAL ESTATE DEVELOPMENT περιλαμβάνουν: 
          </p>
          <ul className="list">
            <li>Ανέγερση και ολοκληρωμένη κατασκευή ακινήτων</li>
            <li>Οργάνωση, διοίκηση και παρακολούθηση της κατασκευής (Project & Construction Management)</li>
            <li>Εκπόνηση μελετών και διαχείριση αδειοδοτήσεων και εγκρίσεων</li>
            <li>Τεχνική και επενδυτική αξιολόγηση οικοπέδων και ακινήτων</li>
            <li>Προετοιμασία για εμπορική αξιοποίηση, μίσθωση ή πώληση.</li>
            <li>Τεχνική υποστήριξη, διαχείριση και συντήρηση ακινήτων μετά την ολοκλήρωσή τους.</li>
          </ul>
          <p className="note">
            Η ανέγερση των ακινήτων πραγματοποιείται με έμφαση στη σωστή κατασκευαστική
            πρακτική, την τεχνική αρτιότητα και τον έλεγχο αποκλίσεων που ενδέχεται να
            επηρεάσουν τη λειτουργικότητα και την αξία του έργου.
          </p>
        </div>
      </section>

      {/* Αξιοποίηση */}
      <section className="services">
        <div className="wrap">
          <h2 className="heading">Ανέγερση &amp; Αξιοποίηση Ακινήτων</h2>
          <p className="lead">
            Η ΚΑΡΤΕΡΙΑ δραστηριοποιείται στην ανάπτυξη, ανέγερση και ολοκληρωμένη κατασκευή ακινήτων, παρέχοντας παράλληλα υποστήριξη για τη λειτουργική και τεχνική διαχείρισή τους,
            με στόχο τη βέλτιστη αξιοποίηση και τη διαχρονική διατήρηση της αξίας τους. 
          </p>
          <p className="lead">Οι υπηρεσίες περιλαμβάνουν:</p>
          <ul className="list">
            <li>Ανάπτυξη, ανέγερση και ολοκληρωμένη κατασκευή ακινήτων, με έμφαση στην ποιοτική, λειτουργική και τεχνικά άρτια υλοποίηση κάθε έργου, από το στάδιο της προετοιμασίας έως την πλήρη αποπεράτωση και παράδοσή του.</li>
            <li>Ανέγερση ακινήτων μέσω αντιπαροχής, αγοράς ή ιδιωτικής ανάπτυξης, με στόχο τη δημιουργία σύγχρονων ακινήτων υψηλής λειτουργικής και εμπορικής αξίας.</li>
            <li>Εκπόνηση και συντονισμός των απαιτούμενων μελετών, καθώς και διαχείριση των διαδικασιών αδειοδότησης και θεσμικής ωρίμανσης του έργου.</li>
            <li>Οργάνωση, διοίκηση και συνεχής παρακολούθηση της κατασκευής (Project & Construction Management), με έλεγχο ποιότητας, κόστους και χρονοδιαγράμματος.</li>
            <li>Συντονισμός συνεργείων, υπεργολάβων, προμηθευτών και τεχνικών συμβούλων καθ’ όλη τη διάρκεια υλοποίησης.</li>
            <li>Έλεγχος της κατασκευαστικής ποιότητας και της συμμόρφωσης με τις εγκεκριμένες μελέτες, τις τεχνικές προδιαγραφές και τις κανονιστικές απαιτήσεις.</li>
            <li>Παράδοση του ακινήτου σε πλήρη λειτουργία και προετοιμασία για αξιοποίηση, μίσθωση ή πώληση.</li>
            <li>Υποστήριξη στη στρατηγική αξιοποίησης και στην εμπορική διάθεση του ακινήτου, με στόχο τη μεγιστοποίηση της επενδυτικής και εμπορικής του αξίας.</li>
          </ul>
          <p className="note">
            Η αξιοποίηση προσεγγίζεται με τρόπο που διασφαλίζει τη λειτουργική επάρκεια,
            την ασφάλεια και τη μακροχρόνια βιωσιμότητα του ακινήτου.
          </p>
        </div>
      </section>

      {/* Πώληση */}
      <section className="sale">
        <div className="wrap">
          <h2 className="heading">Πώληση Ακινήτων</h2>
          <p className="lead">
            Η ΚΑΡΤΕΡΙΑ δραστηριοποιείται στην πώληση ακινήτων, παρέχοντας ολοκληρωμένες
            υπηρεσίες διάθεσης και μεταβίβασης, με τεχνική τεκμηρίωση και οργανωμένη
            διαχείριση της διαδικασίας. Η προσέγγιση βασίζεται στην πλήρη αποτύπωση των
            χαρακτηριστικών κάθε ακινήτου και στη διασφάλιση της νομιμότητας, με στόχο
            την αξιόπιστη και αποτελεσματική ολοκλήρωση της συναλλαγής.
          </p>
          <p className="sublead">Υπηρεσίες</p>
          <ul className="list">
            <li>Διάθεση και πώληση ακινήτων (οικιστικών, επαγγελματικών ή επενδυτικών)</li>
            <li>Τεχνικός έλεγχος και αποτύπωση της υφιστάμενης κατάστασης του ακινήτου</li>
            <li>Συγκέντρωση και έλεγχος των απαιτούμενων δικαιολογητικών για τη μεταβίβαση</li>
            <li>Διασφάλιση συμμόρφωσης του ακινήτου με το ισχύον θεσμικό και κανονιστικό πλαίσιο</li>
            <li>Σύνταξη και οργάνωση τεχνικού φακέλου ακινήτου</li>
            <li>Εκτίμηση τεχνικών και λειτουργικών χαρακτηριστικών που επηρεάζουν την αξία του ακινήτου</li>
            <li>Συντονισμός της διαδικασίας πώλησης και μεταβίβασης έως την ολοκλήρωση της συναλλαγής</li>
            <li>Συνεργασία με νομικούς, συμβολαιογράφους και λοιπούς εμπλεκόμενους για την ολοκλήρωση της μεταβίβασης</li>
          </ul>
        </div>
      </section>

      {/* Θεσμικό Πλαίσιο */}
      <section className="legal">
        <div className="wrap">
          <h2 className="heading">Θεσμικό &amp; Κανονιστικό Πλαίσιο</h2>
          <p>
            Οι υπηρεσίες ανέγερσης και εκμετάλλευσης ακινήτων υλοποιούνται σε συμμόρφωση
            με το ισχύον πολεοδομικό και κανονιστικό πλαίσιο, όπως αυτό ορίζεται από τον
            Νέο Οικοδομικό Κανονισμό (Ν. 4067/2012) και τον Ν. 4495/2017, καθώς και από
            τις εφαρμοστέες διατάξεις που διέπουν την αδειοδότηση, την κατασκευή και τη
            λειτουργία των ακινήτων.
          </p>
          <p>
            Η συμμόρφωση με τις θεσμικές απαιτήσεις ενσωματώνεται σε όλα τα στάδια του
            έργου, από τη φάση των μελετών έως την υλοποίηση και λειτουργία, διασφαλίζοντας
            την ορθή εφαρμογή των εγκρίσεων και την τεχνική επάρκεια των κατασκευών.
          </p>
        </div>
      </section>

      {/* Προσέγγιση */}
      <section className="approach">
        <div className="wrap">
          <h2 className="heading">Η Προσέγγισή μας</h2>
          <p>
            Η ΚΑΡΤΕΡΙΑ προσεγγίζει την ανάπτυξη και εκμετάλλευση ακινήτων με τεχνική
            συνέπεια, οργανωμένο σχεδιασμό και μακροπρόθεσμη οπτική. Λειτουργούμε ως
            τεχνικός σύμβουλος και αξιόπιστος συνομιλητής του επενδυτή ή του ιδιοκτήτη,
            διασφαλίζοντας ότι κάθε ακίνητο υλοποιείται και αξιοποιείται βάσει σαφούς
            στρατηγικής και ελεγχόμενου ρίσκου.
          </p>
        </div>
      </section>

    </div>
  );
}

export default ServiceRealEstate;

